// Detección del flujo "restablecer contraseña", capturada UNA vez al arrancar.
//
// El enlace del correo aterriza en /login#access_token=...&type=recovery, pero
// supabase-js (detectSessionInUrl) BORRA ese hash en cuanto lo procesa
// (`window.location.hash = ''`, GoTrueClient) — y ese borrado además cuenta
// como cambio de ruta, así que cualquier efecto de React que dependa del hash
// se vuelve a ejecutar con la URL ya limpia. Por eso leer `window.location.hash`
// "en el momento adecuado" no es fiable: no existe tal momento, es una carrera
// contra la librería que se pierde de forma intermitente.
//
// Este módulo se importa el PRIMERO en main.jsx, antes que supabase o React, y
// congela el dato en un módulo + sessionStorage. Así sobrevive tanto al borrado
// del hash como a que PlayerProvider nunca se remonte durante la vida de la app.

const KEY = 'nivela_pw_recovery'

function detect() {
  try {
    // Formato nuevo (?token_hash=...&type=recovery): el enlace del correo ya
    // no consume el token al abrirse — se canjea por JS al pulsar "Guardar".
    // Necesario porque Gmail (y otros) escanean los enlaces de los correos, y
    // al ser de un solo uso ese escaneo los gastaba antes de que el usuario
    // llegara a pulsarlos: de ahí el "enlace expirado" al pinchar desde Gmail
    // mientras que pegando la URL a mano sí funcionaba.
    // Basta con token_hash: es un parámetro que SOLO aparece en este flujo, y
    // exigir además type=recovery era frágil — Gmail reescribe los enlaces al
    // pasarlos por su redirección y ese segundo parámetro se puede perder por
    // el camino, dejando la detección en falso y al usuario en el dashboard.
    const qs = new URLSearchParams(window.location.search)
    if (qs.get('token_hash')) return true
    // Formato antiguo (#access_token=...&type=recovery), aún válido para
    // enlaces ya enviados antes de cambiar la plantilla del correo.
    return window.location.hash.includes('type=recovery')
  } catch {
    return false
  }
}

// Congelado al arrancar: cualquier navegación posterior de React Router puede
// dejar la URL sin query params, y para entonces ya haría falta el token.
const TOKEN_HASH = (() => {
  try {
    return new URLSearchParams(window.location.search).get('token_hash')
  } catch {
    return null
  }
})()

/** token_hash del formato nuevo, o null. Se canjea al enviar el formulario. */
export function getRecoveryTokenHash() {
  return TOKEN_HASH
}

if (detect()) {
  try { sessionStorage.setItem(KEY, '1') } catch { /* ignore */ }
}

/** ¿Estamos en un flujo de recuperación de contraseña en esta pestaña? */
export function isPasswordRecovery() {
  if (detect()) return true
  try {
    return sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

/** Se llama al terminar (o abandonar) el flujo, para no dejarlo pegado. */
export function clearPasswordRecovery() {
  try { sessionStorage.removeItem(KEY) } catch { /* ignore */ }
}
